<template>
	<div class="main-footer minwidth">
		<div class="box1 mx1360 between">
			<div class="f-menu">
				<dl>
					<dt>解决方案</dt>
					<dd @click="goPage(14)" class="cur curadm hover-green">藏家服务</dd>
					<dd @click="goPage(15)" class="cur curadm hover-green">金融机构</dd>
					<dd @click="goPage(16)" class="cur curadm hover-green">司法采信</dd>
					<dd @click="goPage(17)" class="cur curadm hover-green">企业资产</dd>
				</dl>
				<dl>
					<dt>资源</dt>
					<dd @click="goPage(18)" class="cur curadm hover-green">帮助中心</dd>
					<dd @click="goPage(19)" class="cur curadm hover-green">开发者（API）</dd>
					<dd @click="goPage(20)" class="cur curadm hover-green">白皮书</dd>
				</dl>
				<dl>
					<dt>公司</dt>
					<dd @click="goPage(21)" class="cur curadm hover-green">关于我们</dd>
					<dd @click="goPage(22)" class="cur curadm hover-green">加入我们</dd>
					<dd @click="goDoclist()" class="cur curadm hover-green">新闻动态</dd>
				</dl>
				<dl>
					<dt>法律</dt>
					<dd @click="goPage(23)" class="cur curadm hover-green">隐私政策</dd>
					<dd @click="goPage(24)" class="cur curadm hover-green">服务条款</dd>
				</dl>
			</div>
			<div class="f-right">
				<div class="logo align-c">
					<img src="@/static/new/logo-grey.jpg" class="p" />
				</div>


				<div class="cn-t">承载历史文明，实现资产价值</div>
				<div class="cn-t2">致力于构建国际化的艺术经济新生态</div>

				<div class="qrcode flexright">
					<ul>
						<li>
							<img src="@/static/new/z-qrcode1.jpg" class="p" />
							<div class="t">艺鉴通</div>
						</li>
						<li>
							<img src="@/static/new/z-qrcode2.jpg" class="p" />
							<div class="t">掌中宝</div>
						</li>
					</ul>
				</div>
			</div>
		</div>

		<div class="copyright">
			<div class="mx1360 tbd">
				<div class="t">@ 2025环太湖艺术动产登记备案综合服务平台.Allrightsreserved</div>
				<div class="t2"><a href="https://beian.miit.gov.cn/">苏ICP备2025208331号-1</a></div>
			</div>
		</div>
	</div>
</template>

<script>
import util from "@/common/util.js"
export default {
	name: 'myfooter',
	props: {
		// 外部参数示例
		// data: {
		//     type: Array,
		//     default: () => []
		// },
	},
	data() {
		return {
			// 内部参数
		}
	},
	methods: {
		goPage(id) {
			if (this.$route.name === 'detail') {
				this.$emit("getDetail", id);
			} else {
				util.tourl("/detail", { id: id })
			}
		},
		goDoclist() {
			if (this.$route.name === 'doclist') {
				return
			} else {
				util.tourl("/doclist")
			}
		},
	},
	mounted() {

	}

}
</script>

<style lang="scss" scoped>
@import "./footer.scss";
</style>